module.exports = __webpack_public_path__ + "img/workbench_icon8.e2eb8db3.svg";